import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';
import { CurrencyPosition } from './enums/CurrencyPosition';

export class Currency {
  id: number;
  name: string;
  code: string;
  symbol: string;

  @Expose({ name: 'symbol_position' })
  position: CurrencyPosition;

  @Expose({ name: 'decimal_place' })
  decimalPlace: number;

  value: string;

  constructor(
    id: number,
    name: string,
    code: string,
    symbol: string,
    position: CurrencyPosition,
    decimalPlace: number,
    value: string
  ) {
    this.id = id;
    this.name = name;
    this.code = code;
    this.symbol = symbol;
    this.position = position;
    this.decimalPlace = decimalPlace;
    this.value = value;
  }

  static fromJson(json: Record<string, any>): Currency {
    return plainToInstance(Currency, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }

  getFormattedValue(): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: this.code,
      minimumFractionDigits: this.decimalPlace,
      maximumFractionDigits: this.decimalPlace,
    }).format(parseFloat(this.value));
  }
}
